module.exports = __webpack_public_path__ + "static/video/adad_hannah.5869ff7.webm";


//////////////////
// WEBPACK FOOTER
// ./src/commons/video/adad_hannah.webm
// module id = JCT5
// module chunks = 0